import React, { PropsWithChildren } from 'react';
import {
	ActivityFeedProvider,
	AdminAppProvider,
	AudioProvider,
	ChatWidgetProvider,
	PrivateAppProvider,
	PublicAppProvider,
	useAuthContext,
} from '../../context';

const AuthenticatedProviders: React.FC<PropsWithChildren> = ({ children }) => {
	const { user } = useAuthContext();

	if (user?.isAccredited || user?.shadow) {
		if (user?.isAdmin) {
			return <AdminAppProvider>{children}</AdminAppProvider>;
		} else {
			return <ChatWidgetProvider>{children}</ChatWidgetProvider>;
		}
	}

	return <>{children}</>;
};

const AfterAuthContextProviders: React.FC<PropsWithChildren> = ({ children }) => {
	const { authenticated, user, isDataLoading } = useAuthContext();

	if (!isDataLoading && user && authenticated) {
		return (
			<PrivateAppProvider>
				<ActivityFeedProvider>
					<AudioProvider>
						<AuthenticatedProviders>{children}</AuthenticatedProviders>
					</AudioProvider>
				</ActivityFeedProvider>
			</PrivateAppProvider>
		);
	}

	if (!isDataLoading && !authenticated) {
		return <PublicAppProvider>{children}</PublicAppProvider>;
	}
};

export default AfterAuthContextProviders;
